import Button from 'components/base/Button';
import React, { useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import authenticationService from 'services/authentication';
import { useNavigate } from 'react-router-dom';

const ResetPasswordForm = () => {
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  const [incomingEmail, setincomingEmail] = useState('');
  const [incomingToken, setincomingToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordsMatch, setPasswordsMatch] = useState(false);
  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const emailParam = query.get('email');
    const tokenParam = query.get('token');

    // Check if emailParam and tokenParam are not null before decoding
    const q_email = emailParam !== null ? decodeURIComponent(emailParam) : '';
    const q_token = tokenParam !== null ? decodeURIComponent(tokenParam) : '';

    setincomingEmail(q_email);
    setincomingToken(q_token);
  }, []);

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassword(e.target.value);
    setPasswordsMatch(e.target.value === confirmPassword);
  };

  const handleConfirmPasswordChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setConfirmPassword(e.target.value);
    setPasswordsMatch(password === e.target.value);
  };

  const handleResetPassword = () => {
    const password = document.getElementById('password') as HTMLInputElement;
    const confirmPassword = document.getElementById(
      'confirmPass'
    ) as HTMLInputElement;
    authenticationService
      .resetPassword({
        incomingEmail,
        password: password.value,
        confirmPassword: confirmPassword.value,
        incomingToken
      })
      .then(() => {
        navigate('/pages/authentication/split/sign-in');
      })
      .catch(() => {
        setModalShow(true);
        console.log('Reset Password Error:', Error);
      });
  };

  return (
    <div className="text-center mb-6">
      <h4 className="text-1000">Reset new password</h4>
      <p className="text-700">Type your new password</p>
      <Form className="mt-5">
        <Form.Control
          className="mb-2"
          id="password"
          type="password"
          value={password}
          onChange={handlePasswordChange}
          placeholder="Type new password"
        />
        <Form.Control
          className="mb-4"
          id="confirmPass"
          type="password"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
          placeholder="Confirm new password"
        />
        <Button
          variant="primary"
          className="w-100"
          onClick={handleResetPassword}
          disabled={!passwordsMatch}
        >
          Set Password
        </Button>
      </Form>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Something went wrong!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>There are a couple of reasons for this</h4>
          <p>
            You may have already confirmed your email. If so, please try logging
            in. Your token may have expired. If so, please try resending the
            confirmation email. If you are still having issues, please contact
            us at support@usenupitch.com
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ResetPasswordForm;
